import React from "react";

export const Map = () => {
  return (
    <div>
      <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d226.17235777279586!2d91.8703851!3d24.9062444!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x375055278de86f9f%3A0x21952505c2e10f24!2sGolden%20Tower!5e0!3m2!1sen!2sbd!4v1661580135291!5m2!1sen!2sbd"></iframe>
    </div>
  );
};
